// extracted by mini-css-extract-plugin
export var accent = "_bs-4";
export var add = "_bs-j";
export var addIcon = "_bs-k";
export var deleteIcon = "_bs-i";
export var disabled = "_bs-9";
export var ellipsis = "_bs-f";
export var error = "_bs-3";
export var form = "_bs-5";
export var hideFocus = "_bs-2";
export var icon = "_bs-7";
export var input = "_bs-e";
export var listItem = "_bs-h";
export var mediumHeight = "_bs-b";
export var noBorder = "_bs-8";
export var noRadius = "_bs-1";
export var shortHeight = "_bs-a";
export var tallHeight = "_bs-c";
export var textInput = "_bs-0";
export var vertical = "_bs-g";
export var veryTallHeight = "_bs-d";
export var widget = "_bs-6";